import dayjs from 'dayjs';

export const getDatesInRange = (startDate: string, endDate: string): string[] => {
  const dates: string[] = [];
  const end = dayjs(endDate);

  let currentDate = dayjs(startDate);

  while (currentDate.isBefore(end) || currentDate.isSame(end)) {
    dates.push(currentDate.format('YYYY-MM-DD'));
    currentDate = currentDate.add(1, 'day');
  }

  return dates;
};
